var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "../../views/base.component";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute, Router } from "@angular/router";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { TranslateService } from "../../translate";
import { ChartParams } from "../../views/chart/chart.component";
import * as qs from 'qs';
import { NumberFormat } from "../../pipes/number-format";
import { BillingService2 } from "../billing.service";
var ConversionComponent = /** @class */ (function (_super) {
    __extends(ConversionComponent, _super);
    function ConversionComponent(eventsService, service2, activatedRoute, filter, translate, router, numberFormat) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.service2 = service2;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.translate = translate;
        _this.router = router;
        _this.numberFormat = numberFormat;
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTime'],
            dateType: 'dateTime'
        };
        _this.chartData = new ChartParams();
        _this.chart2Data = new ChartParams();
        var me = _this;
        var names = [
            'tariffVisitCount',
            'tariffVisitCountUniq',
            'paymentVisitCount',
            'paymentVisitCountUniq',
            'tariffAndPaymentConversion',
            'tariffAndPaymentConversionUniq',
            'paidAndPaymentConversion',
            'paidAndPaymentConversionUniq',
            'firstManualPaidCount',
            'paidCount',
        ].reduce(function (obj, key) {
            if (key.indexOf('Uniq') > 0) {
                var keyU = key.replace('Uniq', '');
                obj[key] = me.__a('yandex.' + keyU) + ' #Уник';
            }
            else {
                obj[key] = me.__a('yandex.' + key);
            }
            return obj;
        }, {});
        _this.chartData.setOptions({ names: names });
        _this.chart2Data.setOptions({
            names: names,
            axis: {
                y: {
                    show: true,
                    max: 100,
                    label: {
                        text: 'Проценты',
                        position: 'outer-middle'
                    },
                    tick: {
                        format: function (y) {
                            return y + ' %';
                        }
                    }
                }
            },
            tooltip: {
                format: {
                    value: function (value) { return me.numberFormat.transform(value, '1.2-2') + ' %'; }
                }
            }
        });
        return _this;
    }
    ConversionComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        fp = me.filter.getCopyFilterParams();
                        if (!!me.isPaginationReload) return [3 /*break*/, 5];
                        return [4 /*yield*/, me.getCharts(fp)];
                    case 1:
                        _a.sent();
                        if (!(me.filter.filterParams.period == 'summary')) return [3 /*break*/, 3];
                        return [4 /*yield*/, me.getStats(fp)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        me.paginationLoader = true;
                        return [4 /*yield*/, me.service2.conversion.pagination(me.filter.filterParams).toPromise()];
                    case 4:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.service2.siteBilling.getRealFullRoute());
                        }
                        me.paginationLoader = false;
                        _a.label = 5;
                    case 5: return [4 /*yield*/, me.getStats(fp)];
                    case 6:
                        _a.sent();
                        me.isPaginationReload = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionComponent.prototype.getCharts = function (fp) {
        return __awaiter(this, void 0, void 0, function () {
            var me, charts, data1, data2, _i, charts_1, row, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        // Графики
                        me.chartData.showLoader();
                        me.chart2Data.showLoader();
                        return [4 /*yield*/, me.service2.conversion.chart(fp).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        data1 = [];
                        data2 = [];
                        for (_i = 0, charts_1 = charts; _i < charts_1.length; _i++) {
                            row = charts_1[_i];
                            key = row[0];
                            if (key === 'x') {
                                data1.push(row);
                                data2.push(row);
                            }
                            else if (key.indexOf('Conversion') > 0) {
                                data2.push(row);
                            }
                            else {
                                data1.push(row);
                            }
                        }
                        me.chartData.data = data1;
                        me.chart2Data.data = data2;
                        me.chartData.hideLoader();
                        me.chart2Data.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionComponent.prototype.getStats = function (fp) {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        return [4 /*yield*/, me.service2.conversion.stats(__assign({}, fp, { paginationDate: me.pagination.getDate() })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.stats = stats;
                        me.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.isPaginationReload = true;
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                return [2 /*return*/];
            });
        });
    };
    ConversionComponent.prototype.onChartTypeChange = function (chartType) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                // await this.getCharts({
                // 	...this.filter.filterParams,
                // 	chartType,
                // });
                this.filter.filterParams.chartType = chartType;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                return [2 /*return*/];
            });
        });
    };
    return ConversionComponent;
}(BaseComponent));
export { ConversionComponent };
